.game {
  --ink: #090c0d;
  --cream: #eadcae;
  --green: #73d95b;
  --green-dim: #3f8f42;
  min-height: 100vh;
  overflow: clip;
  background: #050809;
  color: var(--cream);
  font-family: 'Press Start 2P', 'Courier New', monospace;
  image-rendering: pixelated;
}

.game * {
  box-sizing: border-box;
}
.game a {
  color: inherit;
}

.scanlines {
  position: fixed;
  z-index: 100;
  inset: 0;
  pointer-events: none;
  opacity: 0.055;
  background: repeating-linear-gradient(0deg, transparent 0 3px, #000 4px);
}

.story {
  height: 1225vh;
  min-height: 8100px;
}

.viewport {
  position: sticky;
  top: 0;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: #050809;
}

.world {
  position: absolute;
  left: 0;
  top: 50%;
  display: flex;
  align-items: center;
  width: max-content;
  height: 100%;
  translate: 0 -50%;
  will-change: transform;
}

.progress {
  position: absolute;
  z-index: 20;
  left: 50%;
  bottom: 24px;
  width: min(760px, calc(100vw - 36px));
  min-height: 50px;
  display: grid;
  grid-template-columns: repeat(5, 1fr) auto;
  align-items: stretch;
  gap: 10px;
  transform: translateX(-50%);
  padding: 16px 12px 7px;
  border: 3px solid var(--cream);
  background: rgba(5, 8, 9, 0.92);
  box-shadow: 5px 5px 0 #000;
  font-size: 5px;
}

.progress::before {
  content: '';
  position: absolute;
  left: 12px;
  right: 12px;
  top: 8px;
  height: 5px;
  background: #223026;
}

.progress > i {
  position: absolute;
  z-index: 1;
  left: 12px;
  top: 8px;
  max-width: calc(100% - 24px);
  height: 5px;
  background: repeating-linear-gradient(90deg, var(--green) 0 12px, #3d8f3a 12px 16px);
}

.progress button {
  min-width: 0;
  padding: 4px 3px;
  border: 0;
  color: #718074;
  background: transparent;
  font: inherit;
  line-height: 1.45;
  text-align: left;
  cursor: pointer;
}

.progress button span {
  display: block;
  color: #405146;
  font-size: 4px;
}

.progress button:hover,
.progress button:focus-visible,
.progress .progressActive {
  color: #d5e6bd;
  background: rgba(115, 217, 91, 0.1);
  outline: 0;
}

.progress .progressActive span {
  color: var(--green);
}
.progress b {
  color: var(--green);
}
.progressRoomTitle {
  display: none;
}

.scrollHint {
  position: absolute;
  z-index: 20;
  left: 18px;
  bottom: 82px;
  margin: 0;
  padding: 8px;
  background: rgba(5, 8, 9, 0.86);
  font-size: 5px;
}

.scrollHint b {
  color: var(--green);
}
.mobileInputHint {
  display: none;
}

@media (max-width: 680px) {
  .viewport {
    touch-action: pan-y;
    overscroll-behavior-x: none;
  }
  .progress {
    bottom: 14px;
    width: calc(100vw - 24px);
    min-height: 82px;
    gap: 4px;
    padding: 34px 5px 6px;
    font-size: 4px;
  }
  .progressRoomTitle {
    position: absolute;
    left: 10px;
    top: 7px;
    display: block;
    color: var(--cream);
    font-size: 6px;
    line-height: 1;
  }
  .progress button {
    overflow: hidden;
    padding-inline: 1px;
    font-size: 3px;
    line-height: 1.5;
    text-align: center;
  }
  .progress button span {
    margin-bottom: 2px;
    font-size: 6px;
  }
  .progress > b {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 6px;
  }
  .progress::before,
  .progress > i {
    left: 8px;
    right: 8px;
    top: 21px;
    max-width: calc(100% - 16px);
    height: 4px;
  }
  .scrollHint {
    bottom: 104px;
  }
  .desktopInputHint {
    display: none;
  }
  .mobileInputHint {
    display: inline;
  }
}

@media (max-height: 620px) and (min-width: 681px) {
  .progress {
    bottom: 12px;
  }
}

@media (min-width: 1600px) and (min-height: 800px) {
  .progress {
    width: min(1120px, calc(100vw - 72px));
    min-height: 66px;
    gap: 14px;
    padding: 21px 17px 9px;
    border-width: 4px;
    font-size: 7px;
    box-shadow: 7px 7px 0 #000;
  }
  .progress::before,
  .progress > i {
    left: 17px;
    top: 10px;
    max-width: calc(100% - 34px);
    height: 7px;
  }
  .progress button {
    padding: 6px 5px;
  }
  .progress button span {
    font-size: 5px;
  }
  .scrollHint {
    bottom: 102px;
    font-size: 7px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .world {
    will-change: auto;
  }
}
